const POLAND_VOIVODESHIP_FILES: Record<string, string> = {
  Dolnośląskie: '02_DOLNOSLASKIE_ALL_PC_4326',
  'Kujawsko-Pomorskie': '04_KUJAWSKO-POMORSKIE_ALL_PC_4326',
  Lubelskie: '06_LUBELSKIE_ALL_PC_4326',
  Lubuskie: '08_LUBUSKIE_ALL_PC_4326',
  Łódzkie: '10_LODZKIE_ALL_PC_4326',
  Małopolskie: '12_MALOPOLSKIE_ALL_PC_4326',
  Mazowieckie: '14_MAZOWIECKIE_ALL_PC_4326',
  Opolskie: '16_OPOLSKIE_ALL_PC_4326',
  Podkarpackie: '18_PODKARPACKIE_ALL_PC_4326',
  Podlaskie: '20_PODLASKIE_ALL_PC_4326',
  Pomorskie: '22_POMORSKIE_ALL_PC_4326',
  Śląskie: '24_SLASKIE_ALL_PC_4326',
  Świętokrzyskie: '26_SWIETOKRZYSKIE_ALL_PC_4326',
  'Warmińsko-Mazurskie': '28_WARMINSKO-MAZURSKIE_ALL_PC_4326',
  Wielkopolskie: '30_WIELKOPOLSKIE_ALL_PC_4326',
  Zachodniopomorskie: '32_ZACHODNIOPOMORSKIE_ALL_PC_4326',
};

export { POLAND_VOIVODESHIP_FILES };
